import axios from "axios";
import paths from "routes/paths";
import {
  hideProgressLoader,
  showProgressLoader,
} from "./ProgressLoaderManager";
import { toast } from "react-toastify";
import { baseUrl } from "./baseUrl";

export const asyncInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

asyncInstance.interceptors.request.use(
  (config) => {
    showProgressLoader(); // 👈 Start showing loader
    const bearerToken = localStorage.getItem("bearerToken");
    if (bearerToken) {
      config.headers.Authorization = `Bearer ${bearerToken}`;
    }
    return config;
  },
  (error) => {
    hideProgressLoader(); // 👈 Hide loader on request error
    return Promise.reject(error);
  }
);
asyncInstance.interceptors.response.use(
  (response) => {
    hideProgressLoader(); // 👈 Hide loader after success
    return response;
  },
  (error) => {
    hideProgressLoader(); // 👈 Hide loader after failure

    const expectedError =
      error.response?.status >= 400 && error.response?.status < 500;
    const errorMessage =
      error.response?.data?.message || "An unexpected error occurred";

    if (!navigator.onLine) {
      toast.error("Network error - please check your internet connection");
      return Promise.reject({ message: "Network Error" });
    }

    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = paths.login;
    }

    return Promise.reject(errorMessage);
  }
);

export default asyncInstance;
